<template>
    <v-container fluid class="pa-2" style="margin-top: 2%; max-width: 100%">
      <template>
        <v-row justify="center">
          <v-dialog v-model="confirmDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">{{ $t('system.alert') }}</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemdialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red accent-4"
                  class="white--text"
                  @click="confirmDialog = false"
                  >{{ this.messageDismissButton }}</v-btn
                >
                <v-btn
                  v-if="showConfirmButton"
                  color="red accent-4"
                  class="white--text"
                  @click="deleteFromDatabase"
                  >{{ this.messageConfirmButton }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="referentesAdminWarningDialog" persistent max-width="640">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">{{ $t('system.alert') }}</span>
              </v-card-title>
              <v-card-text>
                <p class="mb-3">{{ $t('crudUnidades.messages.referentesNotAdminWarning') }}</p>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>{{ $t('user.username') }}</th>
                        <th>{{ $t('profiles.title') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="u in referentesAdminWarningUsers" :key="u.id_usuario">
                        <td>{{ u.nome_usuario || u.login }}</td>
                        <td>{{ formatReferentePerfil(u) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="grey darken-1" text @click="cancelReferentesAdminWarning">
                  {{ $t('button.cancel') }}
                </v-btn>
                <v-btn color="primary" class="white--text" @click="confirmReferentesAdminWarning">
                  {{ $t('crudUnidades.messages.referentesNotAdminContinue') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
  
      <recursos-operacionais-split-layout
        ref="detalheSplit"
        :linha="linhaSelecionada"
        preview-type="unit"
        :preview-item="unidadeSelecionada"
        :preview-items="selecionadas"
        :parametros-total="selecionadas.length"
        :parametros-page.sync="parametrosPage"
        :parametros-label="parametrosLabel"
        :token="token"
        :can-edit="canEditLinha"
        :can-insert="canInsert"
        @map-action="onMapAction"
        @unidade-linhas-changed="onUnidadeLinhasChanged"
        @parametros-save="saveParametros"
        @parameters-tab-opened="onParametrosTabOpened"
      >
        <template #parametros>
          <v-form ref="formParametros" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  v-model="editedItem.cod_unidade"
                  :label="$t('crudUnidades.form.fields.unitCode')"
                  :rules="[codUnidadeRules]"
                  :disabled="isCodigoDisabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" md="5">
                <v-text-field
                  v-model="editedItem.descricao_unidade"
                  :label="$t('crudUnidades.form.fields.description')"
                  :rules="[(v) => !!v || $t('crudUnidades.validation.descriptionRequired')]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="3">
                <v-text-field v-model="editedItem.cod_integracao_erp" :label="$t('turnosPassageiros.headers.integrationCode')"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-switch
                  v-model="editedItem.ativa"
                  :label="$t('crudUnidades.form.fields.active')"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <LazySelect
                  ref="cercaCentroSelectParametros"
                  get-url="getCercaslazy"
                  :text="cercaSelectText"
                  value="id_cerca"
                  :label="$t('crudUnidades.form.fields.centerFence')"
                  @input="onCercaCentroInput"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.tempo_maximo_permanencia_linha_minutos"
                  :label="$t('crudUnidades.form.fields.maxRideTime')"
                  type="number"
                  min="1"
                  suffix="min"
                  clearable
                  :hint="$t('crudUnidades.form.fields.maxRideTimeHint')"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.velocidade_media_estimativa_kmh"
                  :label="$t('crudUnidades.form.fields.rideTimeAverageSpeed')"
                  type="number"
                  min="1"
                  suffix="km/h"
                  clearable
                  :hint="$t('crudUnidades.form.fields.rideTimeAverageSpeedHint')"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.raio_centro_unidade"
                  :label="$t('crudUnidades.form.fields.centerRadius')"
                  type="number"
                  min="1"
                  suffix="m"
                  clearable
                  :hint="$t('crudUnidades.form.fields.centerRadiusHint')"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
            <UnidadeBalancoTiposVeiculo
              v-if="editedItem.id_unidade != null"
              :itens="balancoTipos"
              :loading="balancoLoading"
            />
            <UnidadeReferentesEditor
              :grupos="referentesGrupos"
              :label-options="labelReferentesOptions"
              @add="addReferenteGrupo"
              @remove="removeReferenteGrupo"
            />
            <UnidadeAreasTable
              v-if="editedItem.id_unidade != null && canViewAreas"
              :id-unidade="editedItem.id_unidade"
              :can-edit="canEditAreas"
            />
            <UnidadeLocations
              v-if="canViewLocations && editedItem.id_unidade != null"
              :id-unidade="editedItem.id_unidade"
              :locations="locationsUnidade"
              :loading="loadingLocations"
              :can-insert="canInsertLocation"
              :can-edit="canEditLocation"
              :can-toggle="canToggleLocation"
              @changed="loadLocationsUnidade(editedItem.id_unidade)"
            />
          </v-form>
        </template>
        <template #create-entity>
          <v-form ref="formCreate" v-model="formValidado" class="pa-2">
            <v-text-field
              v-model="editedItem.cod_unidade"
              :label="$t('crudUnidades.form.fields.unitCode')"
              :rules="[codUnidadeRules]"
              :disabled="isCodigoDisabled"
              dense
              outlined
            />
            <v-text-field
              v-model="editedItem.descricao_unidade"
              :label="$t('crudUnidades.form.fields.description')"
              :rules="[(v) => !!v || $t('crudUnidades.validation.descriptionRequired')]"
              dense
              outlined
            />
            <v-text-field
              v-model="editedItem.cod_integracao_erp"
              :label="$t('turnosPassageiros.headers.integrationCode')"
              dense
              outlined
            />
            <v-switch
              v-model="editedItem.ativa"
              :label="$t('crudUnidades.form.fields.active')"
              class="mt-0 mb-2"
              hide-details
            />
            <LazySelect
              ref="cercaCentroSelect"
              get-url="getCercaslazy"
              :text="cercaSelectText"
              value="id_cerca"
              :label="$t('crudUnidades.form.fields.centerFence')"
              class="mb-2"
              @input="onCercaCentroInput"
            />
            <v-expansion-panels v-model="associarLinhasPanel" flat class="unidade-expansion mb-2">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <span class="subtitle-2">
                    {{ $t('crudUnidades.form.fields.associateLines') }}
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <MultiplaEscolha
                    v-if="associarLinhasPanel === 0"
                    ref="linhasAssociarSelect"
                    lazy
                    get-url="getLinhaslazy"
                    text="nome_linha"
                    value="id_linha"
                    :label="$t('operation.searchLine')"
                    :max-items="3"
                    v-bind:selected-items.sync="linhasParaAssociar"
                    @update:selectedItems="onLinhasAssociarUpdate"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <UnidadeReferentesEditor
              :grupos="referentesGrupos"
              :label-options="labelReferentesOptions"
              @add="addReferenteGrupo"
              @remove="removeReferenteGrupo"
            />
            <template v-if="canAlterPermission()">
              <div class="subtitle-2 mb-2">{{ $t('profiles.title') }}</div>
              <v-text-field
                v-model="searchPerfis"
                append-icon="mdi-magnify"
                :label="$t('system.search')"
                single-line
                hide-details
                dense
                class="mb-2"
                @focus="ensurePerfisCarregados"
              />
              <v-data-table
                :headers="headersPerfis"
                :items="perfis"
                :search="searchPerfis"
                item-key="id_perfil_usuario"
                v-model="perfisSelected"
                show-select
                dense
                class="elevation-0 mb-2"
                locale="pt"
                :loading="loadingPerfis"
                :loading-text="$t('system.messages.loading')"
                :items-per-page="5"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15, -1],
                  'items-per-page-text': 'Perfis por página:'
                }"
                @item-selected="togglePerfil"
                @toggle-select-all="toggleAllPerfis"
              />
            </template>
            <div class="d-flex justify-end pt-2">
              <v-btn color="primary darken-1" class="white--text mr-2" small @click="close">
                {{ $t('button.cancel') }}
              </v-btn>
              <v-btn color="primary darken-1" class="white--text" small @click="save">
                {{ $t('button.save') }}
              </v-btn>
            </div>
          </v-form>
        </template>
      <merus-data-table
        :headers="headers"
        :items="unidades"
        mostrar-inativos
        :loading="loadingtable"
        :default-multi-sort="defaultSort"
        :loading-text="$t('crudUnidades.loading')"
        :server-items-length="totalUnidades"
        :items-per-page="numberOfRows"
        :items-per-page-last-option="itemsPerPageLastOption"
        :server-sort-by="serverSortBy"
        :server-sort-desc="serverSortDesc"
        @update:options="onTableOptions"
        @update:filters="onFiltersUpdate"
        item-key="id_unidade"
        show-select
        v-model="selecionadas"
        cod-tabela="UNIDADES" @update:headers="headers = $event">
        <template v-slot:toolbar>
          <CadastroToolbar
            :title="$t('crudUnidades.title')"
            :token="token"
            :items="[]"
            :load-items-for-export="loadItemsForExport"
            background-export
            :export-filters="searchFilters"
            :export-sort-by="serverSortBy"
            :export-sort-desc="serverSortDesc"
            :export-total="totalUnidades"
            :selected-ids="selectedUnidadesIds"
            id-field="id_unidade"
            :csv-title="canEdit ? $t('crudUnidades.title') : null"
            :pdf-title="$t('crudUnidades.title')"
            :pdf-headers="headers"
            pdf-filename="unidades"
            :csv-headers="headersCSV"
            csv-filename="unidades"
            :help-dialog-csv-fields="helpCSV"
            :help-dialog-csv-model="$t('crudUnidades.title')"
            :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvunidades/' : null"
            @saveBulk="saveBulk"
            hide-search
          >
            <template v-slot:extension>
              <v-row>
                <v-col cols="12" sm="4" md="6">  
                  <v-switch
                  v-model="mostrarInativos"
                  :label="$t('crudVeiculos.showInactive')"
                  class="ml-3 mr-4"
                  hide-details
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="4" md="6" style="margin-top: 15px">
                  <LazySelect
                    ref="linhaFiltroSelect"
                    get-url="getLinhaslazy"
                    text="nome_linha"
                    value="id_linha"
                    :label="$tc('line.self', 1)"
                    class="mr-4"
                    style="max-width: 320px;"
                    @input="onLinhaFiltroInput"
                  />
                </v-col>
              </v-row>
            </template>
            <template v-slot:add v-if="canInsert">
              <v-tooltip v-if="canInsert" top>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark small class="mb-2 mr-2" fab v-on="on" @click="startCreateUnidade">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('crudUnidades.form.title.create') }}</span>
            </v-tooltip>
            </template>
          </CadastroToolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="red" @click.stop="deleteItem(item)" :disabled="item.ativa === 0 || !canDelete"
            >mdi-delete</v-icon
          >
        </template>
      </merus-data-table>
      </recursos-operacionais-split-layout>
    </v-container>
  </template>
  
<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import LazySelect from "./Selects/LazySelect.vue";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";
import UnidadeReferentesEditor from "./UnidadeReferentesEditor.vue";
import UnidadeLocations from "./UnidadeLocations.vue";
import UnidadeBalancoTiposVeiculo from "./UnidadeBalancoTiposVeiculo.vue";
import { balancoPercentuaisErro, balancoPayload, mesclarBalancoComTipos } from "@/utils/unidadeBalanco";
import UnidadeAreasTable from "./Linhas/UnidadeAreasTable.vue";

import EventBus from "../utils/eventBus";
import RecursosOperacionaisSplitLayout from "./Linhas/RecursosOperacionaisSplitLayout.vue";
import { sameSelection, mergeSelectionWithPage, dropFromSelection, currentPageItem } from "@/utils/tableSelection";
import serverTableMixin from "@/mixins/serverTableMixin";
import translateDbField from "@/utils/translateDbField";
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";
  
  export default {
    components: {
      MerusDataTable,
      CadastroToolbar,
      LazySelect,
      MultiplaEscolha,
      UnidadeReferentesEditor,
      UnidadeLocations,
      UnidadeBalancoTiposVeiculo,
      UnidadeAreasTable,
      RecursosOperacionaisSplitLayout,
    },
    mixins: [serverTableMixin],
    data: () => ({
    headers: [],
      search: "",
      user: null,
      token: null,
      showConfirmButton: true,
      messageConfirmButton: null,
      messageDismissButton: null,
      formValidado: true,
      dialog: false,
      operacao: 0,
      confirmDialog: false,
      mensagemdialog: "",
      isCodigoDisabled: false,
      loadingtable: false,
      totalUnidades: 0,
      numberOfRows: 10,
      itemsPerPageLastOption: 1000,
      lastItemsPerPageBeforeTodos: null,
      pageNumber: 1,
      serverSortBy: [],
      serverSortDesc: [],
      searchFilters: {},
      linhasAssociadas: [],
      linhasAssociadasCarregadas: false,
      linhasParaAssociar: [],
      linhasParaDesassociar: [],
      linhasSelecionadasCache: {},
      selectedCercaDetail: null,
      cercaDetailRequestSeq: 0,
      loadingLinhasAssociadas: false,
      linhasAssociadasRequestSeq: 0,
      maxRotasLinhasMapa: 15,
      associarLinhasPanel: undefined,
      desassociarLinhasPanel: undefined,
      referentesGrupos: [],
      referenteGrupoKeySeq: 0,
      referentesRequestSeq: 0,
      balancoTipos: [],
      balancoLoading: false,
      balancoRequestSeq: 0,
      /** id_unidade cujo balanço está em `balancoTipos`; só então o save o envia (evita zerar o que não carregou). */
      balancoCarregadoDe: null,
      locationsUnidade: [],
      loadingLocations: false,
      locationsRequestSeq: 0,
      labelReferentes: [],
      referentesAdminWarningDialog: false,
      referentesAdminWarningUsers: [],
      referentesAdminWarningResolve: null,
      rotasUnidade: [],
      loadingRotas: false,
      mapaUnidadePanel: undefined,
      rotasRequestSeq: 0,
      idLinhaMapa: 'all',
      unidades: [],
      mostrarInativos: false,
      idLinhaSelected: null,
      permissoes: [],
      recursos: [],
      empresasPermitidas: [],
      activeTab: 0,
      searchPerfis: "",
      perfis: [],
      perfisSelected: [],
      loadingPerfis: false,
      perfisCarregados: false,
      unitAccessPermissaoId: null,
      lastCreatedUnitAccessPermissaoId: null,
      editedIndex: -1,
      editedItem: {
        id_unidade: null,
        cod_unidade: null,
        descricao_unidade: null,
        ativa: 1,
        ativa_extenso: null,
        cod_integracao_erp: null,
        id_cerca_centro: null,
        tempo_maximo_permanencia_linha_minutos: null,
        velocidade_media_estimativa_kmh: null,
        raio_centro_unidade: null,
      },
      deletedItem: {
        id_unidade: null,
        cod_unidade: null,
        descricao_unidade: null,
        ativa: 1,
        ativa_extenso: null,
        cod_integracao_erp: null,
        id_cerca_centro: null,
        tempo_maximo_permanencia_linha_minutos: null,
        velocidade_media_estimativa_kmh: null,
        raio_centro_unidade: null,
      },
      defaultItem: {
        id_unidade: null,
        cod_unidade: null,
        descricao_unidade: null,
        ativa: 1,
        ativa_extenso: null,
        cod_integracao_erp: null,
        id_cerca_centro: null,
        tempo_maximo_permanencia_linha_minutos: null,
        velocidade_media_estimativa_kmh: null,
        raio_centro_unidade: null,
      },
      canInsert: false,
      canEdit: false,
      canDelete: false,
      canEditLinha: false,
      canViewLocations: false,
      canViewAreas: false,
      canEditAreas: false,
      canInsertLocation: false,
      canEditLocation: false,
      canToggleLocation: false,
      linhaSelecionada: null,
      unidadeSelecionada: null,
      selecionadas: [],
      parametrosPage: 0,
    }),
    computed: {
      /** Unidade exibida na página atual do paginador de parâmetros. */
      itemParametrosAtual() {
        return currentPageItem(this.selecionadas, this.parametrosPage);
      },
      parametrosLabel() {
        const item = this.itemParametrosAtual;
        if (!item) return null;
        return [item.cod_unidade, item.descricao_unidade].filter(Boolean).join(" — ") || null;
      },
      selectedUnidadesIds() {
        return (this.selecionadas || [])
          .map((u) => (u && u.id_unidade != null ? u.id_unidade : null))
          .filter((id) => id != null);
      },
      headersPerfis() {
        return [
          { text: this.$t('profiles.headers.profileId'), value: "id_perfil_usuario", align: " d-none" },
          { text: this.$t('profiles.headers.profile'), value: "descricao_tipo_usuario" },
        ];
      },
      defaultSort() {
        return [
          { value: 'ativa_extenso', options: { text: this.$t('system.labels.decreasing'), value: -1} },
          { value: 'cod_unidade', options: { text: this.$t('system.labels.increasing'), value: 1} }];
      },
      formTitle() {
        return this.editedIndex === -1 ? this.$t('crudUnidades.form.title.create') : this.$t('crudUnidades.form.title.edit');
      },
      labelReferentesOptions() {
        if (Array.isArray(this.labelReferentes) && this.labelReferentes.length) {
          return this.labelReferentes.map((row) => ({
            id_label_referente: row.id_label_referente,
            label: translateDbField(row.translation_key, row.descricao_label_referente),
          }));
        }
        return [
          {
            id_label_referente: 1,
            label: this.$t('database.labelDescription.responsible'),
          },
          {
            id_label_referente: 2,
            label: this.$t('database.labelDescription.technician'),
          },
        ];
      },
      headersCSV() {
        return [
          { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
          { text: this.$t('crudVeiculos.csvHeaders.operacao'), value: 'operacao' },
          { text: this.$t('crudUnidades.headers.code'), value: 'cod_unidade' },
          { text: this.$t('crudUnidades.headers.description'), value: 'descricao_unidade' },
          { text: this.$t('crudUnidades.headers.active'), value: 'ativa' },
          { text: this.$t('crudUnidades.csvHeaders.integrationCode'), value: 'cod_integracao_erp' },
          { text: this.$t('crudUnidades.csvHeaders.centerFence'), value: 'cod_cerca_centro' },
          { text: this.$t('crudUnidades.csvHeaders.lines'), value: 'cod_linhas' },
        ];
      },
      helpCSV() {
        return [
          {
            label: this.$t('crudUnidades.headers.code'),
            description: this.$t('crudUnidades.helpCSV.unitCode'),
            example: 'UNI001',
            key: 'cod_unidade',
          },
          {
            label: this.$t('crudUnidades.headers.description'),
            description: this.$t('crudUnidades.helpCSV.description'),
            example: 'Unidade Centro',
            key: 'descricao_unidade',
          },
          {
            label: this.$t('crudUnidades.headers.active'),
            description: this.$t('crudUnidades.helpCSV.active'),
            example: '1',
            key: 'ativa',
          },
          {
            label: this.$t('crudUnidades.csvHeaders.integrationCode'),
            description: this.$t('crudUnidades.helpCSV.integrationCode'),
            example: 'ERP01',
            key: 'cod_integracao_erp',
          },
          {
            label: this.$t('crudUnidades.csvHeaders.centerFence'),
            description: this.$t('crudUnidades.helpCSV.centerFence'),
            example: 'CERCA01',
            key: 'cod_cerca_centro',
          },
          {
            label: this.$t('crudUnidades.csvHeaders.lines'),
            description: this.$t('crudUnidades.helpCSV.lines'),
            example: 'L1100 | L1200',
            key: 'cod_linhas',
          },
        ];
      },
      selectedCercaCentro() {
        return this.selectedCercaDetail;
      },
      linhasDesassociarExtraData() {
        const id = this.editedItem && this.editedItem.id_unidade;
        if (id == null || id === '') return null;
        return { id_unidade: id };
      },
      idsLinhasAssociadasAtuais() {
        return (this.linhasAssociadas || [])
          .map((l) => Number(l.id_linha))
          .filter((id) => Number.isFinite(id));
      },
      /** Linhas que permanecem/ficarão associadas (para carregar rotas no mapa). */
      idsLinhasParaRotas() {
        const remover = new Set(
          (this.linhasParaDesassociar || [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id))
        );
        const ids = new Set(
          this.idsLinhasAssociadasAtuais.filter((id) => !remover.has(id))
        );
        (this.linhasParaAssociar || []).forEach((id) => {
          const n = Number(id);
          if (Number.isFinite(n)) ids.add(n);
        });
        return [...ids].sort((a, b) => a - b);
      },
      idsLinhasParaRotasKey() {
        return this.idsLinhasParaRotas.join(',');
      },
      linhasParaMapa() {
        const byId = new Map();
        const addLinha = (l) => {
          if (!l || l.id_linha == null) return;
          const id = Number(l.id_linha);
          if (!Number.isFinite(id) || byId.has(id)) return;
          byId.set(id, {
            id_linha: id,
            label: [l.cod_linha, l.nome_linha].filter(Boolean).join(' — ') || String(id),
          });
        };
        const remover = new Set(
          (this.linhasParaDesassociar || [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id))
        );
        (this.linhasAssociadas || []).forEach((l) => {
          if (!remover.has(Number(l.id_linha))) addLinha(l);
        });
        Object.values(this.linhasSelecionadasCache || {}).forEach(addLinha);
        return this.idsLinhasParaRotas
          .map((id) => byId.get(id))
          .filter(Boolean);
      },
      opcoesLinhaMapa() {
        return [
          { id_linha: 'all', label: this.$t('crudUnidades.form.fields.unidadeMapAllLines') },
          ...this.linhasParaMapa,
        ];
      },
      rotasLinhaMapa() {
        if (this.idLinhaMapa == null || this.idLinhaMapa === '' || this.idLinhaMapa === 'all') {
          return this.rotasUnidade || [];
        }
        const id = Number(this.idLinhaMapa);
        return (this.rotasUnidade || []).filter((r) => Number(r.id_linha) === id);
      },
      mostrarMapaUnidade() {
        const temCerca = this.editedItem && this.editedItem.id_cerca_centro != null && this.editedItem.id_cerca_centro !== '';
        // Em edição, o painel pode abrir sob demanda (linhas associadas só carregam ao expandir).
        return temCerca || this.idsLinhasParaRotas.length > 0 || this.editedIndex !== -1;
      },
    },
    watch: {
      selecionadas(list, prev) {
        // MerusDataTable emite `input` duas vezes por mudança: compara por chave.
        if (sameSelection(list, prev, "id_unidade")) return;
        this.parametrosPage = 0;
      },
      itemParametrosAtual(item, prev) {
        const atual = item && item.id_unidade;
        const anterior = prev && prev.id_unidade;
        if (String(atual) === String(anterior)) return;
        this.selecionarUnidade(item || null);
      },
      canViewLocations(pode) {
        // Os recursos do usuário chegam depois do mount; recarrega a unidade já aberta.
        if (pode && this.editedItem && this.editedItem.id_unidade != null && !this.dialog) {
          this.loadLocationsUnidade(this.editedItem.id_unidade);
        }
      },
      mostrarInativos() {
        this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
        this.pageNumber = 1;
        this.serverTableLoad();
      },
      idLinhaSelected() {
        this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
        this.pageNumber = 1;
        this.serverTableLoad();
      },
      dialog(val) {
        if (val) {
          this.onDialogOpen();
        } else {
          this.associarLinhasPanel = undefined;
          this.desassociarLinhasPanel = undefined;
          this.mapaUnidadePanel = undefined;
          this.rotasUnidade = [];
          this.loadingRotas = false;
          this.loadingLinhasAssociadas = false;
          this.linhasAssociadasCarregadas = false;
          this.loadingPerfis = false;
          this.perfisCarregados = false;
          this.idLinhaMapa = 'all';
          this.selectedCercaDetail = null;
          this.linhasParaAssociar = [];
          this.linhasParaDesassociar = [];
          this.linhasSelecionadasCache = {};
          this.linhasAssociadas = [];
          this.resetCercaCentroSelect();
          this.resetLinhasSelects();
        }
      },
      mostrarMapaUnidade(val) {
        if (!val) {
          this.mapaUnidadePanel = undefined;
        }
      },
      associarLinhasPanel(val) {
        if (!this.dialog || val !== 0) return;
        this.$nextTick(() => this.restoreLinhasSelectSelection('linhasAssociarSelect', this.linhasParaAssociar));
      },
      desassociarLinhasPanel(val) {
        if (!this.dialog || val !== 0) return;
        this.ensureLinhasAssociadas()
          .then(() => {
            this.$nextTick(() =>
              this.restoreLinhasSelectSelection('linhasDesassociarSelect', this.linhasParaDesassociar)
            );
          })
          .catch((e) => EventBus.$emit('show-error', { error: e }));
      },
      idsLinhasParaRotasKey() {
        if (!this.dialog) return;
        this.syncLinhaMapaSelecionada();
      },
      mapaUnidadePanel(val) {
        if (!this.dialog || val !== 0) return;
        this.ensureMapaSupportData()
          .then(() => this.syncLinhaMapaSelecionada())
          .catch((e) => EventBus.$emit('show-error', { error: e }));
      },
      activeTab(val) {
        if (!this.dialog || val !== 1) return;
        this.ensurePerfisCarregados();
      },
      '$i18n.locale'() {
        this.initialize();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {
    },
    methods: {

      onLinhaFiltroInput(val) {
        this.idLinhaSelected = val;
      },
      columnFiltersOnly() {
        const baseKeys = { somente_ativas: true, id_linha: true };
        const out = {};
        Object.keys(this.searchFilters || {}).forEach((k) => {
          if (!baseKeys[k]) out[k] = this.searchFilters[k];
        });
        return out;
      },
      serverTableBaseFilters() {
        const base = {};
        if (!this.mostrarInativos) base.somente_ativas = '1';
        if (this.idLinhaSelected) base.id_linha = String(this.idLinhaSelected);
        return base;
      },
      /** Reaponta a seleção para os objetos da página sem perder marcados em outras páginas. */
      resyncAposReload() {
        this.selecionadas = mergeSelectionWithPage(this.selecionadas, this.unidades, "id_unidade");
        const item = this.itemParametrosAtual;
        if (item) {
          this.unidadeSelecionada = item;
          this.loadParametrosUnidade(item);
        }
      },
      /** Vínculos linha↔unidade alterados na aba Linhas do painel de detalhe. */
      onUnidadeLinhasChanged() {
        this.linhasAssociadasCarregadas = false;
      },
      onMapAction({ action }) {
        const split = this.$refs.detalheSplit;
        if (action === "create-unit") {
          this.startCreateUnidade();
          return;
        }
        if (action === "close-create") {
          this.close({ fromMap: true });
          return;
        }
        if (!split) return;
        if (action === "manage-line-association" || action === "toggle-lines-drawer") {
          if (typeof split.focarAssociacaoLinhas === "function") {
            split.focarAssociacaoLinhas();
          }
        }
      },
      startCreateUnidade() {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.isCodigoDisabled = false;
        this.resetReferentesGrupos();
        this.resetBalancoUnidade();
        this.dialog = true;
        this.$nextTick(() => {
          const form = this.$refs.formCreate || this.$refs.form;
          if (form && typeof form.resetValidation === "function") {
            form.resetValidation();
          }
          const split = this.$refs.detalheSplit;
          if (split && typeof split.openCreateDrawer === "function") {
            split.openCreateDrawer({ silent: true });
          }
        });
      },
      createReferenteGrupo() {
        this.referenteGrupoKeySeq += 1;
        return {
          _key: `ref-${this.referenteGrupoKeySeq}`,
          idUsuarios: [],
          usuariosOptions: [],
          id_label_referente: null,
        };
      },
      resetReferentesGrupos() {
        this.referenteGrupoKeySeq = 0;
        this.referentesGrupos = [this.createReferenteGrupo()];
      },
      addReferenteGrupo() {
        this.referentesGrupos.push(this.createReferenteGrupo());
      },
      removeReferenteGrupo(index) {
        if (!Array.isArray(this.referentesGrupos)) return;
        if (index < 0 || index >= this.referentesGrupos.length) return;
        this.referentesGrupos.splice(index, 1);
        if (!this.referentesGrupos.length) {
          this.referentesGrupos = [this.createReferenteGrupo()];
        }
      },
      buildReferentesPayload() {
        const out = [];
        const seen = new Set();
        (this.referentesGrupos || []).forEach((grupo) => {
          if (!grupo || grupo.id_label_referente == null || grupo.id_label_referente === '') return;
          const idLabel = Number(grupo.id_label_referente);
          if (!Number.isFinite(idLabel) || idLabel <= 0) return;
          (grupo.idUsuarios || []).forEach((rawId) => {
            const idUsuario = Number(rawId);
            if (!Number.isFinite(idUsuario) || idUsuario <= 0) return;
            if (seen.has(idUsuario)) return;
            seen.add(idUsuario);
            out.push({
              id_usuario: idUsuario,
              id_label_referente: idLabel,
            });
          });
        });
        return out;
      },
      /**
       * Grupo incompleto: usuários sem tipo, ou tipo sem usuários.
       * Cartões totalmente vazios são ignorados.
       * @returns {string|null} chave i18n do erro, ou null se válido
       */
      getReferentesValidationErrorKey() {
        const grupos = Array.isArray(this.referentesGrupos) ? this.referentesGrupos : [];
        for (let i = 0; i < grupos.length; i += 1) {
          const grupo = grupos[i];
          if (!grupo) continue;
          const usuarios = (grupo.idUsuarios || [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id) && id > 0);
          const idLabel = Number(grupo.id_label_referente);
          const hasLabel = Number.isFinite(idLabel) && idLabel > 0;
          const hasUsuarios = usuarios.length > 0;
          if (hasUsuarios && !hasLabel) {
            return 'crudUnidades.validation.referenteLabelRequired';
          }
          if (hasLabel && !hasUsuarios) {
            return 'crudUnidades.validation.referenteUsersRequired';
          }
        }
        return null;
      },
      applyReferentesFromRows(rows) {
        this.referenteGrupoKeySeq = 0;
        const list = Array.isArray(rows) ? rows : [];
        if (!list.length) {
          this.referentesGrupos = [this.createReferenteGrupo()];
          return;
        }
        const byLabel = new Map();
        list.forEach((row) => {
          if (!row || row.id_label_referente == null) return;
          const idUsuario = Number(row.id_usuario);
          if (!Number.isFinite(idUsuario) || idUsuario <= 0) return;
          const key = String(row.id_label_referente);
          if (!byLabel.has(key)) byLabel.set(key, []);
          byLabel.get(key).push({
            id_usuario: idUsuario,
            nome_usuario: row.nome_usuario,
            login: row.login,
            id_label_referente: Number(row.id_label_referente),
          });
        });
        const grupos = [];
        byLabel.forEach((users, key) => {
          this.referenteGrupoKeySeq += 1;
          grupos.push({
            _key: `ref-${this.referenteGrupoKeySeq}`,
            id_label_referente: Number(key),
            idUsuarios: users.map((u) => u.id_usuario),
            usuariosOptions: users.map((u) => ({
              id_usuario: u.id_usuario,
              nome_usuario: u.nome_usuario,
              login: u.login,
            })),
          });
        });
        this.referentesGrupos = grupos.length ? grupos : [this.createReferenteGrupo()];
      },
      loadLabelReferentes() {
        return apiController.request(apiController.endpoints.getallLabelreferentes, {
          data: {},
          silent: true,
        }).then((response) => {
          this.labelReferentes = Array.isArray(response.data) ? response.data : [];
        }).catch(() => {
          this.labelReferentes = [];
        });
      },
      loadReferentesUnidade(idUnidade) {
        const id = Number(idUnidade);
        if (!Number.isFinite(id) || id <= 0) {
          this.resetReferentesGrupos();
          return Promise.resolve();
        }
        const seq = ++this.referentesRequestSeq;
        return apiController.request(apiController.endpoints.getReferentesunidade, {
          data: { id_unidade: id },
          silent: true,
        }).then((response) => {
          if (seq !== this.referentesRequestSeq) return;
          this.applyReferentesFromRows(response.data);
        }).catch(() => {
          if (seq !== this.referentesRequestSeq) return;
          this.resetReferentesGrupos();
        });
      },
      /** Catálogo de tipos de veículo (base), carregado uma vez por montagem da tela. */
      loadTiposVeiculosCatalogo() {
        if (!this._tiposVeiculosCatalogo) {
          this._tiposVeiculosCatalogo = apiController.request(apiController.endpoints.getallTiposveiculos, {
            silent: true,
          }).then((response) => {
            const rows = Array.isArray(response.data) ? response.data : [];
            return rows.map((row) => ({
              id_tipo_veiculo: row.id_tipo_veiculo,
              descricao: translateDbField(row.translation_key, row.descricao_tipo_veiculo)
                || row.descricao_tipo_veiculo
                || String(row.id_tipo_veiculo),
            }));
          }).catch(() => {
            this._tiposVeiculosCatalogo = null;
            return [];
          });
        }
        return this._tiposVeiculosCatalogo;
      },
      resetBalancoUnidade() {
        this.balancoRequestSeq += 1;
        this.balancoTipos = [];
        this.balancoLoading = false;
        this.balancoCarregadoDe = null;
      },
      loadBalancoUnidade(idUnidade) {
        const id = Number(idUnidade);
        if (!Number.isFinite(id) || id <= 0) {
          this.resetBalancoUnidade();
          return Promise.resolve();
        }
        const seq = ++this.balancoRequestSeq;
        this.balancoCarregadoDe = null;
        this.balancoLoading = true;
        return Promise.all([
          this.loadTiposVeiculosCatalogo(),
          apiController.request(apiController.endpoints.getBalancotiposveiculounidade, {
            data: { id_unidade: id },
            silent: true,
          }),
        ]).then(([tipos, response]) => {
          if (seq !== this.balancoRequestSeq) return;
          const salvos = Array.isArray(response.data) ? response.data : [];
          this.balancoTipos = mesclarBalancoComTipos(tipos, salvos);
          // Sem catálogo não há como mostrar o balanço salvo: não marca como carregado.
          this.balancoCarregadoDe = tipos.length ? id : null;
        }).catch(() => {
          if (seq !== this.balancoRequestSeq) return;
          this.balancoTipos = [];
          this.balancoCarregadoDe = null;
        }).finally(() => {
          if (seq === this.balancoRequestSeq) this.balancoLoading = false;
        });
      },
      loadLocationsUnidade(idUnidade) {
        const seq = ++this.locationsRequestSeq;
        this.locationsUnidade = [];
        if (!this.canViewLocations) return Promise.resolve();
        this.loadingLocations = true;
        return apiController.request(apiController.endpoints.getLocationsunidade, {
          data: { id_unidade: Number(idUnidade) },
          silent: true,
        }).then((response) => {
          if (seq !== this.locationsRequestSeq) return;
          this.locationsUnidade = Array.isArray(response.data) ? response.data : [];
        }).catch(() => {
          if (seq !== this.locationsRequestSeq) return;
          this.locationsUnidade = [];
        }).finally(() => {
          if (seq === this.locationsRequestSeq) this.loadingLocations = false;
        });
      },
      centralizarCercaNoMapa(cerca) {
        const split = this.$refs.detalheSplit;
        if (split && typeof split.previewAndFocusCerca === "function") {
          split.previewAndFocusCerca(cerca);
        }
      },
      selecionarUnidade(item) {
        this.unidadeSelecionada = item || null;
        if (!item) {
          this.linhaSelecionada = null;
          return;
        }
        this.loadParametrosUnidade(item);
        this.linhaSelecionada = null;
      },
      loadParametrosUnidade(item) {
        if (this.dialog) return;
        this.editedIndex = item && item.id_unidade != null ? 0 : -1;
        this.editedItem = Object.assign({}, this.defaultItem, item || {});
        this.isCodigoDisabled = !!(item && item.id_unidade != null);
        if (item && item.id_unidade != null) {
          this.loadReferentesUnidade(item.id_unidade);
          this.loadBalancoUnidade(item.id_unidade);
          this.loadLocationsUnidade(item.id_unidade);
        } else {
          this.resetReferentesGrupos();
          this.resetBalancoUnidade();
          this.locationsUnidade = [];
        }
        // A aba Parâmetros (v-tab-item) pode ainda não ter montado o LazySelect.
        this.$nextTick(() => this.syncCercaCentroSelectParametros());
      },
      /** Quando a aba Parâmetros abre, o LazySelect passa a existir — repõe a cerca de referência. */
      onParametrosTabOpened() {
        if (this.dialog) return;
        this.$nextTick(() => {
          this.syncCercaCentroSelectParametros();
          // v-tab-item (eager=false) pode montar o select só no tick seguinte.
          if (!this.$refs.cercaCentroSelectParametros) {
            this.$nextTick(() => this.syncCercaCentroSelectParametros());
          }
        });
      },
      saveParametros() {
        if (this.dialog || this.editedItem.id_unidade == null) return;
        this.save();
      },
      syncCercaCentroSelectParametros() {
        const idCerca = this.editedItem && this.editedItem.id_cerca_centro;
        this.syncCercaCentroSelect(idCerca, {
          fetchDetail: idCerca != null && idCerca !== "",
        });
      },
      async resolveLinhaFromUnidade(unidade) {
        try {
          const res = await apiController.request(apiController.endpoints.getLinhasassociadas, {
            data: [unidade.id_unidade],
            silent: true,
          });
          const linhas = Array.isArray(res.data) ? res.data : [];
          if (!linhas.length) return null;
          return { ...linhas[0] };
        } catch (e) {
          EventBus.$emit("show-error", { error: e });
          return null;
        }
      },
      canAlterPermission() {
        return this.user?.is_superadmin === 1 || this.recursos.some((r) => r.rota === "/api/v1.0/updateperfil");
      },
      initialize() {
        if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
          const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
          this.serverSortBy = serverSortBy;
          this.serverSortDesc = serverSortDesc;
        }
        this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
        this.populaPermissoes();
        this.populaRecursos();
        this.loadLabelReferentes();
        this.serverTableLoad();
      },
      serverTableLoad(options) {
        const state = {
          pageNumber: this.pageNumber,
          numberOfRows: this.numberOfRows,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
          lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
          total: this.totalUnidades,
        };
        const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
        this.loadingtable = true;
        apiController.request(apiController.endpoints.getallUnidades, {
          data: params,
          onSuccess: (response) => {
            const data = response.data;
            const totalNum = data && data.total != null && data.total !== '' ? Number(data.total) : NaN;
            if (data && !Number.isNaN(totalNum) && Array.isArray(data.items)) {
              const dataForPager = { items: data.items, total: totalNum };
              this.unidades = data.items;
              const updates = computePageState(dataForPager, { page, rowsPerPage, sortByArr, sortDescArr }, state, this.itemsPerPageLastOption);
              this.totalUnidades = updates.total;
              this.pageNumber = updates.pageNumber;
              this.numberOfRows = updates.numberOfRows;
              this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
              this.serverSortBy = updates.serverSortBy;
              this.serverSortDesc = updates.serverSortDesc;
            } else {
              this.unidades = Array.isArray(data) ? data : [];
              this.totalUnidades = this.unidades.length;
            }
            this.loadingtable = false;
            this.$nextTick(() => this.resyncAposReload());
          },
          onError: (e) => {
            this.loadingtable = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                this.$t('system.messages.accessDenied');
              this.autorizacaoDialog = true;
            }
          },
        });
      },
      async loadItemsForExport(onProgress) {
        const selected = this.selecionadas;
        if (selected && selected.length > 0) {
          if (typeof onProgress === "function") onProgress(100);
          return selected.slice();
        }
        return fetchAllServerPagesForExport({
          fetchPage: async (params) => {
            const response = await apiController.request(
              apiController.endpoints.getallUnidades,
              { data: params, silent: true },
            );
            return response && response.data;
          },
          state: {
            total: this.totalUnidades,
            serverSortBy: this.serverSortBy,
            serverSortDesc: this.serverSortDesc,
            searchFilters: this.searchFilters,
          },
          onProgress,
        });
      },
      onDialogOpen() {
        this.activeTab = 0;
        this.searchPerfis = "";
        this.associarLinhasPanel = undefined;
        this.desassociarLinhasPanel = undefined;
        this.mapaUnidadePanel = undefined;
        this.perfisSelected = [];
        this.perfis = [];
        this.perfisCarregados = false;
        this.loadingPerfis = false;
        this.unitAccessPermissaoId = null;
        this.lastCreatedUnitAccessPermissaoId = null;
        this.rotasUnidade = [];
        this.idLinhaMapa = 'all';
        this.selectedCercaDetail = null;
        this.linhasParaAssociar = [];
        this.linhasParaDesassociar = [];
        this.linhasSelecionadasCache = {};
        this.linhasAssociadas = [];
        this.linhasAssociadasCarregadas = false;
        this.resetReferentesGrupos();
        this.resetBalancoUnidade();

        this.$nextTick(() => {
          this.syncCercaCentroSelect(this.editedItem && this.editedItem.id_cerca_centro, {
            fetchDetail: !!(this.editedItem && this.editedItem.id_cerca_centro),
          });
        });
      },
      resetLinhasSelects() {
        const associar = this.$refs.linhasAssociarSelect;
        if (associar && typeof associar.resetData === 'function') {
          associar.resetData();
        }
        const desassociar = this.$refs.linhasDesassociarSelect;
        if (desassociar && typeof desassociar.resetData === 'function') {
          desassociar.resetData();
        }
      },
      restoreLinhasSelectSelection(refName, ids) {
        const ref = this.$refs[refName];
        if (!ref || typeof ref.setData !== 'function') return;
        const list = Array.isArray(ids) ? [...ids] : [];
        const cachedItems = list
          .map((id) => this.linhasSelecionadasCache[String(id)])
          .filter(Boolean);
        if (cachedItems.length && typeof ref.cacheSelectedItems === 'function') {
          ref.cacheSelectedItems(cachedItems, 'id_linha');
        }
        ref.setData(list);
      },
      ensureLinhasAssociadas() {
        if (this.editedIndex === -1 || !this.editedItem?.id_unidade) {
          this.linhasAssociadas = [];
          this.linhasAssociadasCarregadas = true;
          return Promise.resolve([]);
        }
        if (this.linhasAssociadasCarregadas) {
          return Promise.resolve(this.linhasAssociadas);
        }
        return this.populaLinhasAssociadas();
      },
      ensureMapaSupportData() {
        const tasks = [this.ensureLinhasAssociadas()];
        const idCerca = this.editedItem && this.editedItem.id_cerca_centro;
        if (idCerca != null && idCerca !== '') {
          tasks.push(this.ensureCercaCentroDetail(idCerca));
        }
        return Promise.all(tasks);
      },
      cacheLinhasFromSelect(refName, ids) {
        const ref = this.$refs[refName];
        const next = { ...this.linhasSelecionadasCache };
        (Array.isArray(ids) ? ids : []).forEach((id) => {
          if (id == null || id === '') return;
          const cached =
            (ref && typeof ref.getCachedSelectedItem === 'function'
              ? ref.getCachedSelectedItem(id)
              : null) ||
            (ref && ref.selectedItemCache ? ref.selectedItemCache[String(id)] : null);
          if (cached) {
            next[String(id)] = cached;
          }
        });
        this.linhasSelecionadasCache = next;
      },
      onLinhasAssociarUpdate(ids) {
        this.linhasParaAssociar = Array.isArray(ids) ? [...ids] : [];
        this.cacheLinhasFromSelect('linhasAssociarSelect', this.linhasParaAssociar);
      },
      onLinhasDesassociarUpdate(ids) {
        this.linhasParaDesassociar = Array.isArray(ids) ? [...ids] : [];
        this.cacheLinhasFromSelect('linhasDesassociarSelect', this.linhasParaDesassociar);
      },
      cercaSelectText(item) {
        if (!item) return "";
        const cod = item.cod_cerca != null ? String(item.cod_cerca).trim() : "";
        const nome = item.nome_cerca != null ? String(item.nome_cerca).trim() : "";
        if (cod && nome) return `${cod} — ${nome}`;
        return cod || nome || "";
      },
      onCercaCentroInput(val) {
        this.editedItem.id_cerca_centro = val;
        if (val == null || val === "") {
          this.selectedCercaDetail = null;
          return;
        }
        this.ensureCercaCentroDetail(val).then((detail) => {
          if (detail) this.centralizarCercaNoMapa(detail);
        });
      },
      cercaCentroSelectRefs() {
        return [this.$refs.cercaCentroSelectParametros, this.$refs.cercaCentroSelect].filter(Boolean);
      },
      resetCercaCentroSelect() {
        this.cercaCentroSelectRefs().forEach((ref) => {
          if (ref && typeof ref.resetData === "function") {
            ref.resetData();
          }
        });
      },
      syncCercaCentroSelect(idOrItem, options = {}) {
        const fetchDetail = options.fetchDetail !== false;
        const refs = this.cercaCentroSelectRefs();
        if (idOrItem == null || idOrItem === "") {
          this.selectedCercaDetail = null;
          refs.forEach((ref) => {
            if (ref && typeof ref.resetData === "function") {
              ref.resetData();
            }
          });
          return;
        }
        const id = typeof idOrItem === "object" ? idOrItem.id_cerca : idOrItem;
        const item =
          typeof idOrItem === "object" && idOrItem
            ? {
                id_cerca: idOrItem.id_cerca,
                nome_cerca: idOrItem.nome_cerca,
                cod_cerca: idOrItem.cod_cerca,
              }
            : this.selectedCercaDetail &&
              Number(this.selectedCercaDetail.id_cerca) === Number(id)
              ? {
                  id_cerca: this.selectedCercaDetail.id_cerca,
                  nome_cerca: this.selectedCercaDetail.nome_cerca,
                  cod_cerca: this.selectedCercaDetail.cod_cerca,
                }
              : null;
        refs.forEach((ref) => {
          if (item && typeof ref.cacheSelectedItems === "function") {
            ref.cacheSelectedItems([item], "id_cerca");
          }
          if (typeof ref.setData === "function") {
            ref.setData(id);
          }
        });
        if (fetchDetail && typeof idOrItem !== "object") {
          this.ensureCercaCentroDetail(id);
        }
      },
      ensureCercaCentroDetail(idCerca) {
        if (idCerca == null || idCerca === "") {
          this.selectedCercaDetail = null;
          return Promise.resolve(null);
        }
        const id = Number(idCerca);
        if (!Number.isFinite(id)) {
          this.selectedCercaDetail = null;
          return Promise.resolve(null);
        }
        if (
          this.selectedCercaDetail &&
          Number(this.selectedCercaDetail.id_cerca) === id &&
          (this.selectedCercaDetail.geojson ||
            this.selectedCercaDetail.shape ||
            (this.selectedCercaDetail.lat_centro != null &&
              this.selectedCercaDetail.lng_centro != null))
        ) {
          return Promise.resolve(this.selectedCercaDetail);
        }
        const requestSeq = ++this.cercaDetailRequestSeq;
        return apiController
          .request(apiController.endpoints.getCercaporid, {
            params: { id },
            silent: true,
          })
          .then((res) => {
            if (requestSeq !== this.cercaDetailRequestSeq) return null;
            const rows = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
            const detail = rows[0] || null;
            this.selectedCercaDetail = detail;
            if (detail) {
              this.syncCercaCentroSelect(
                {
                  id_cerca: detail.id_cerca,
                  nome_cerca: detail.nome_cerca,
                  cod_cerca: detail.cod_cerca,
                },
                { fetchDetail: false }
              );
            }
            return detail;
          })
          .catch(() => {
            if (requestSeq === this.cercaDetailRequestSeq) {
              this.selectedCercaDetail = null;
            }
            return null;
          });
      },
      ensurePerfisCarregados() {
        if (!this.canAlterPermission() || this.perfisCarregados || this.loadingPerfis) {
          return Promise.resolve();
        }

        this.loadingPerfis = true;
        return this.populaPerfis()
          .then(() => {
            if (!this.dialog) return;
            if (this.editedIndex === -1) {
              this.perfisCarregados = true;
              return;
            }
            return this.resolveUnitAccessPermissaoId(this.editedItem.cod_unidade)
              .then((idPermissao) => {
                if (!this.dialog) return;
                this.unitAccessPermissaoId = idPermissao;
                return this.populaPerfisPorPermissao(idPermissao);
              })
              .then(() => {
                if (this.dialog) this.perfisCarregados = true;
              });
          })
          .catch((e) => {
            EventBus.$emit('show-error', { error: e });
          })
          .finally(() => {
            this.loadingPerfis = false;
          });
      },
      populaPerfis() {
        return apiController.request(apiController.endpoints.getallPerfisusuarios, { silent: true })
          .then((response) => {
            this.perfis = response.data.map((p) => ({
              ...p,
              selected: false,
            }));
          });
      },
      resolveUnitAccessPermissaoId(codUnidade) {
        if (!codUnidade) return Promise.resolve(null);
        return apiController.request(apiController.endpoints.getPermissoesgranulares, { silent: true })
          .then((response) => {
            const permissao = response.data.find((p) =>
              p.translation_key === "database.permissions.unitAccess" &&
              typeof p.descricao_permissao === "string" &&
              p.descricao_permissao.includes(codUnidade)
            );
            return permissao ? permissao.id_permissao : null;
          });
      },
      populaPerfisPorPermissao(idPermissao) {
        if (!idPermissao) return Promise.resolve();
        return apiController.request(apiController.endpoints.getPerfisporpermissao, { params: { id: idPermissao }, silent: true })
          .then((response) => {
            const selectedById = new Map(response.data.map((p) => [p.id_perfil_usuario, !!p.selected]));
            this.perfis = this.perfis.map((p) => ({
              ...p,
              selected: selectedById.get(p.id_perfil_usuario) || false,
            }));
            this.perfisSelected = this.perfis.filter((p) => p.selected);
          });
      },
      savePerfisPermissao(idPermissao) {
        // Só persiste se a aba de perfis foi carregada; evita limpar vínculos sem o usuário abrir a aba.
        if (!this.canAlterPermission() || !idPermissao || !this.perfisCarregados) return Promise.resolve();

        const perfisSelecionados = this.perfis.filter((p) => p.selected).map((p) => p.id_perfil_usuario);
        return apiController.request(apiController.endpoints.deletePermissoesperfispermissao, {
            data: { id_permissao: idPermissao },
            silent: true,
          })
          .then(() => {
            if (perfisSelecionados.length === 0) return;
            const temp = perfisSelecionados.map((idPerfil) => [idPerfil, idPermissao]);
            return apiController.request(apiController.endpoints.insertPermissoesbulk, { data: temp, silent: true });
          });
      },
      togglePerfil(obj) {
        let { item, value } = obj;
        item.selected = value;
      },
      toggleAllPerfis(obj) {
        let { items, value } = obj;
        items.forEach((item) => {
          let perfilItem = this.perfis.find((p) => p.id_perfil_usuario === item.id_perfil_usuario);
          if (perfilItem) {
            perfilItem.selected = value;
          }
        });
      },
      populaEmpresasPermitidas() {
        this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
          return rec.id_empresa
        });
      },
      populaPermissoes() {
        apiController.request(apiController.endpoints.getPermissoesusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.permissoes = response.data;
          },
        });
      },
      populaRecursos() {
        if (this.user.is_superadmin === 1) {
          apiController.request(apiController.endpoints.getallRecursos, {
            onSuccess: (response) => {
              this.recursos = response.data;
              this.canEdit = true;
              this.canInsert = true;
              this.canDelete = true;
              this.canEditLinha = true;
              this.canViewLocations = true;
              this.canInsertLocation = true;
              this.canEditLocation = true;
              this.canToggleLocation = true;
              this.canViewAreas = true;
              this.canEditAreas = true;
              this.populaEmpresasPermitidas();
            },
          });
        } else {
          apiController.request(apiController.endpoints.getRecursosusuario, {
            params: { id: this.user.id_usuario },
            onSuccess: (response) => {
              this.recursos = response.data;
              this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateunidade");
              this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertunidade");
              this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteunidade");
              this.canEditLinha = this.recursos.some((r) => r.rota === "/api/v1.0/updatelinha");
              this.canViewLocations = this.recursos.some((r) => r.rota === "/api/v1.0/getlocationsunidade");
              this.canInsertLocation = this.recursos.some((r) => r.rota === "/api/v1.0/insertlocationunidade");
              this.canEditLocation = this.recursos.some((r) => r.rota === "/api/v1.0/updatelocationunidade");
              this.canToggleLocation = this.recursos.some((r) => r.rota === "/api/v1.0/deletelocationunidade");
              this.canViewAreas = this.recursos.some((r) => r.rota === "/api/v1.0/getareasunidades");
              this.canEditAreas = this.recursos.some((r) => r.rota === "/api/v1.0/associaunidadesarea");
              this.populaEmpresasPermitidas();
            },
          });
        }
      },
      populaLinhasAssociadas() {
        if (!this.editedItem?.id_unidade) {
          this.linhasAssociadas = [];
          this.linhasAssociadasCarregadas = true;
          this.syncLinhaMapaSelecionada();
          return Promise.resolve([]);
        }

        const requestSeq = ++this.linhasAssociadasRequestSeq;
        this.loadingLinhasAssociadas = true;
        return apiController.request(apiController.endpoints.getLinhasassociadas, {
          data: [this.editedItem.id_unidade],
          silent: true,
        })
          .then((response) => {
            if (requestSeq !== this.linhasAssociadasRequestSeq || !this.dialog) return [];
            this.linhasAssociadas = response.data || [];
            this.linhasAssociadasCarregadas = true;
            this.syncLinhaMapaSelecionada();
            return this.linhasAssociadas;
          })
          .catch((e) => {
            if (requestSeq !== this.linhasAssociadasRequestSeq || !this.dialog) return [];
            this.linhasAssociadas = [];
            this.linhasAssociadasCarregadas = true;
            this.syncLinhaMapaSelecionada();
            throw e;
          })
          .finally(() => {
            if (requestSeq === this.linhasAssociadasRequestSeq) {
              this.loadingLinhasAssociadas = false;
            }
          });
      },
      syncLinhaMapaSelecionada() {
        const ids = this.idsLinhasParaRotas;
        if (!ids.length) {
          this.idLinhaMapa = 'all';
          this.rotasUnidade = [];
          this.loadingRotas = false;
          return;
        }
        const atual = this.idLinhaMapa;
        if (atual !== 'all' && atual != null && atual !== '') {
          const idAtual = Number(atual);
          if (!Number.isFinite(idAtual) || !ids.includes(idAtual)) {
            this.idLinhaMapa = ids.length > this.maxRotasLinhasMapa ? ids[0] : 'all';
          }
        } else if (atual == null || atual === '') {
          this.idLinhaMapa = ids.length > this.maxRotasLinhasMapa ? ids[0] : 'all';
        } else if (atual === 'all' && ids.length > this.maxRotasLinhasMapa) {
          // Evita buscar rotas de dezenas/centenas de linhas de uma vez.
          this.idLinhaMapa = ids[0];
        }
        if (this.mapaUnidadePanel === 0) {
          this.populaRotasUnidade();
        }
      },
      populaRotasUnidade() {
        if (this.mapaUnidadePanel !== 0) return;

        let ids = this.idsLinhasParaRotas;
        const requestSeq = ++this.rotasRequestSeq;
        if (!ids.length) {
          this.rotasUnidade = [];
          this.loadingRotas = false;
          return;
        }
        if (this.idLinhaMapa !== 'all' && this.idLinhaMapa != null && this.idLinhaMapa !== '') {
          const id = Number(this.idLinhaMapa);
          ids = Number.isFinite(id) ? [id] : ids;
        } else if (ids.length > this.maxRotasLinhasMapa) {
          this.rotasUnidade = [];
          this.loadingRotas = false;
          return;
        }
        this.loadingRotas = true;
        const idSet = new Set(ids);
        apiController.request(apiController.endpoints.getRotasporlinha, {
          data: ids,
          silent: true,
          onSuccess: (response) => {
            if (requestSeq !== this.rotasRequestSeq) return;
            const rows = Array.isArray(response.data) ? response.data : [];
            this.rotasUnidade = rows.filter((r) => idSet.has(Number(r.id_linha)));
            this.loadingRotas = false;
          },
          onError: () => {
            if (requestSeq !== this.rotasRequestSeq) return;
            this.rotasUnidade = [];
            this.loadingRotas = false;
          },
        });
      },
      populaUnidades() {
        this.serverTableLoad();
      },
    editItem(item) {
      this.loadParametrosUnidade(item);
      this.unidadeSelecionada = item;
      const split = this.$refs.detalheSplit;
      if (split && typeof split.abrirAbaParametros === "function") {
        split.abrirAbaParametros();
      }
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, this.defaultItem, item);
      this.mensagemdialog = this.$t('crudUnidades.messages.confirmDeactivation', { code: item.cod_unidade });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('crudUnidades.messages.no');
      this.messageConfirmButton = this.$t('crudUnidades.messages.yes');
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      this.deletedItem.ativa = 0;
      const deletedId = this.deletedItem && this.deletedItem.id_unidade;

      apiController.request(apiController.endpoints.updateUnidade, {
        data: this.deletedItem,
        onSuccess: (response) => {
          if (deletedId != null) {
            this.selecionadas = dropFromSelection(this.selecionadas, [deletedId], "id_unidade");
          }
          this.updateTable(response);
        },
      });
      },
      close({ fromMap } = {}) {
        this.dialog = false;
        const form = this.$refs.formCreate || this.$refs.form;
        if (form && typeof form.resetValidation === "function") {
          form.resetValidation();
        }
        if (!fromMap) {
          const split = this.$refs.detalheSplit;
          if (split && typeof split.closeCreateDrawer === "function") {
            split.closeCreateDrawer({ silent: true });
          }
        }
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.isCodigoDisabled = false;
          this.resetReferentesGrupos();
          this.resetBalancoUnidade();
          const item = this.itemParametrosAtual;
          if (item) this.loadParametrosUnidade(item);
        });
      },
      saveLinhas(idUnidade) {
        const jaAssociadas = new Set(this.idsLinhasAssociadasAtuais);
        const temp = (this.linhasParaAssociar || [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id) && !jaAssociadas.has(id))
          .map((id) => [idUnidade, id]);

        if (temp.length > 0) {
          apiController.request(apiController.endpoints.associaLinhasbulk, {
            data: temp,
            onSuccess: (response) => {
              if (this.operacao === 0) {
                let debug = true;
                console.log("debug", debug);
              } else {
                this.updateTable(response);
              }
            },
          });
        }
      },
    insertRecurso(idUnidade) {
      let recurso = {
        rota: `unidade/${idUnidade}`,
        cod_recurso: `UNIDADE/${idUnidade}`,
        id_tipo_recurso: 4,
        id_unidade: idUnidade
      };

      apiController.request(apiController.endpoints.insertRecurso, {
        data: recurso,
        onSuccess: (response) => {
          this.insertPermissao(response.data.insertId);
        },
      });
      },
      insertPermissao(idRecurso) {
        let permissao = {
          descricao_permissao: `Acesso Unidade ${this.editedItem.cod_unidade}`,
          translation_key: 'database.permissions.unitAccess'
        };

      apiController.request(apiController.endpoints.insertUnidadepermissao, {
        data: permissao,
        onSuccess: (response) => {
          this.lastCreatedUnitAccessPermissaoId = response.data.insertId;
          this.insertRecursosPermissao(response.data.insertId, idRecurso);
        },
      });
      },
      insertRecursosPermissao(idPermissao, idRecurso) {
        let temp = [[idPermissao, idRecurso]];

      apiController.request(apiController.endpoints.insertRecursospermissaobulk, {
        data: temp,
        onSuccess: (response) => {
          this.updateTable(response);
        },
      });
      },
      desassociaLinhas(resp) {
        const temp = (this.linhasParaDesassociar || [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id));

        if (temp.length > 0) {
          apiController.request(apiController.endpoints.desassociaLinhasbulk, {
            data: temp,
            onSuccess: (response) => {
              this.updateTable(response);
            },
          });
        } else {
          this.updateTable(resp);
        }
      },
    save() {
      const form = this.dialog
        ? (this.$refs.formCreate || this.$refs.form)
        : (this.$refs.formParametros || this.$refs.form);
      if (form) form.validate();
      if (!this.formValidado) return;

      const referentesValidationKey = this.getReferentesValidationErrorKey();
      if (referentesValidationKey) {
        EventBus.$emit('show-error', { error: this.$t(referentesValidationKey) });
        return;
      }

      // Vazio grava NULL: a unidade volta a herdar o valor das configurações.
      this.editedItem.tempo_maximo_permanencia_linha_minutos =
        this.editedItem.tempo_maximo_permanencia_linha_minutos != null
          && this.editedItem.tempo_maximo_permanencia_linha_minutos !== ""
          ? Number(this.editedItem.tempo_maximo_permanencia_linha_minutos)
          : null;
      this.editedItem.velocidade_media_estimativa_kmh =
        this.editedItem.velocidade_media_estimativa_kmh != null
          && this.editedItem.velocidade_media_estimativa_kmh !== ""
          ? Number(this.editedItem.velocidade_media_estimativa_kmh)
          : null;
      this.editedItem.raio_centro_unidade =
        this.editedItem.raio_centro_unidade != null
          && this.editedItem.raio_centro_unidade !== ""
          ? Number(this.editedItem.raio_centro_unidade)
          : null;

      // O balanço só é editado na aba Parâmetros e só segue se já foi carregado desta unidade.
      const enviaBalanco = !this.dialog
        && this.editedItem.id_unidade != null
        && this.balancoCarregadoDe === Number(this.editedItem.id_unidade);
      if (enviaBalanco) {
        const erroBalanco = balancoPercentuaisErro(this.balancoTipos);
        if (erroBalanco) {
          EventBus.$emit('show-alert', {
            mensagem: this.$t(erroBalanco === 'range'
              ? 'crudUnidades.form.balanco.rangeError'
              : 'crudUnidades.form.balanco.saveSumError'),
            tipo: 'warning',
          });
          return;
        }
      }

      const referentes = this.buildReferentesPayload();
      const payload = Object.assign({}, this.editedItem, { referentes });
      if (enviaBalanco) {
        payload.balanco_tipos_veiculo = balancoPayload(this.balancoTipos);
      }

      const persist = () => {
        if (this.editedItem.id_unidade == null) {
          this.operacao = 0;
          this.editedIndex = -1;
          apiController.request(apiController.endpoints.insertUnidade, {
            data: payload,
            onSuccess: (response) => {
              this.insertRecurso(response.data.insertId);
              this.saveLinhas(response.data.insertId);
            },
          });
          return;
        }
        this.operacao = 1;
        this.editedIndex = 0;
        apiController.request(apiController.endpoints.updateUnidade, {
          data: payload,
          onSuccess: (response) => {
            this.saveLinhas(this.editedItem.id_unidade);
            this.desassociaLinhas(response);
          },
        });
      };

      // Garante ids já associados antes de filtrar inserts (evita duplicar vínculo).
      this.ensureLinhasAssociadas()
        .then(() => this.confirmReferentesAdministradores(referentes))
        .then((proceed) => {
          if (proceed) persist();
        })
        .catch((e) => EventBus.$emit('show-error', { error: e }));
    },
    isUsuarioAdministrador(usuario) {
      if (!usuario) return false;
      return Number(usuario.is_administrador) === 1
        || usuario.is_administrador === true
        || Number(usuario.is_superadmin) === 1
        || usuario.is_superadmin === true;
    },
    formatReferentePerfil(usuario) {
      if (!usuario) return '—';
      return translateDbField(usuario.translation_key, usuario.descricao_tipo_usuario)
        || usuario.descricao_tipo_usuario
        || '—';
    },
    confirmReferentesAdministradores(referentes) {
      const ids = (referentes || [])
        .map((r) => Number(r && r.id_usuario))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (!ids.length) return Promise.resolve(true);

      return apiController.request(apiController.endpoints.getUsuariosporids, {
        data: { id_usuarios: ids },
        silent: true,
      }).then((response) => {
        const users = Array.isArray(response.data) ? response.data : [];
        const nonAdmins = users.filter((u) => !this.isUsuarioAdministrador(u));
        if (!nonAdmins.length) return true;
        return this.openReferentesAdminWarning(nonAdmins);
      });
    },
    openReferentesAdminWarning(users) {
      return new Promise((resolve) => {
        this.referentesAdminWarningUsers = Array.isArray(users) ? users : [];
        this.referentesAdminWarningResolve = resolve;
        this.referentesAdminWarningDialog = true;
      });
    },
    confirmReferentesAdminWarning() {
      this.referentesAdminWarningDialog = false;
      const resolve = this.referentesAdminWarningResolve;
      this.referentesAdminWarningResolve = null;
      this.referentesAdminWarningUsers = [];
      if (typeof resolve === 'function') resolve(true);
    },
    cancelReferentesAdminWarning() {
      this.referentesAdminWarningDialog = false;
      const resolve = this.referentesAdminWarningResolve;
      this.referentesAdminWarningResolve = null;
      this.referentesAdminWarningUsers = [];
      if (typeof resolve === 'function') resolve(false);
    },
    saveBulk(result) {
      this.operacao = 3;
      apiController.request(apiController.endpoints.upsertUnidadesbulk, {
        data: result,
        onSuccess: (response) => {
          this.updateTable(response);
        },
      });
    },
      updateTable(response) {
        let mensagem = "";
        let tipo = response.data.erro ? "error" : "success";
        
        if (response.data.erro) {
          if (this.operacao == 0) {
            mensagem = this.$t('crudUnidades.messages.errorInsert') +  response.data.mensagem;
          } else if (this.operacao == 1) {
            mensagem = this.$t('crudUnidades.messages.errorUpdate') + response.data.mensagem;
          } else if (this.operacao == 3) {
            mensagem = this.$t('crudUnidades.messages.errorInsertBulk') + response.data.mensagem;
          } else {
            mensagem = this.$t('crudUnidades.messages.errorDelete') + response.data.mensagem;
          }
        } else {
          if (this.operacao == 0) {
            mensagem = this.$t('crudUnidades.messages.successInsert');
          } else if (this.operacao == 1) {
            mensagem = this.$t('crudUnidades.messages.successUpdate');
          } else if (this.operacao == 3) {
            mensagem = this.$t('crudUnidades.messages.successInsertBulk');
          } else {
            mensagem = this.$t('crudUnidades.messages.successDelete');
          }
        }
        
        const getIdPermissao = () => {
          if (this.operacao === 0) return Promise.resolve(this.lastCreatedUnitAccessPermissaoId);
          if (this.operacao === 1) {
            if (this.unitAccessPermissaoId) return Promise.resolve(this.unitAccessPermissaoId);
            return this.resolveUnitAccessPermissaoId(this.editedItem.cod_unidade).then((id) => {
              this.unitAccessPermissaoId = id;
              return id;
            });
          }
          return Promise.resolve(null);
        };

        getIdPermissao()
          .then((idPermissao) => this.savePerfisPermissao(idPermissao))
          .catch((e) => {
            EventBus.$emit('show-error', { error: e });
          })
          .finally(() => {
            EventBus.$emit('show-alert', { mensagem, tipo });
            if (this.operacao !== 2 && this.operacao !== 3) {
              this.close();
            }
            this.initialize();
          });
      },
    codUnidadeRules() {
      if (!validador(this.editedItem.cod_unidade, 1, 20, 0, 1)) {
        return this.$t('crudUnidades.validation.unitCodeRequired');
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.unidade-expansion >>> .v-expansion-panel {
  border: 1px solid rgba(0, 0, 0, 0.28);
  border-radius: 8px;
  overflow: hidden;
}

.unidade-expansion >>> .v-expansion-panel::before {
  box-shadow: none !important;
}

.unidade-expansion >>> .v-expansion-panel--active {
  border-color: var(--v-primary-base, #1976d2);
}

.unidade-expansion >>> .v-expansion-panel-header {
  min-height: 48px;
}
</style>